import React from 'react'
import OrderShapedQueue from '../shared/OrderShapedQueue'

const OrdersQueue = () => <OrderShapedQueue queue="orders" title="Orders" />

export default OrdersQueue
